import { render, staticRenderFns } from "./BookingHistoryComponent.vue?vue&type=template&id=0109a492"
import script from "./BookingHistoryComponent.vue?vue&type=script&lang=js"
export * from "./BookingHistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports